const STORAGE_PREFIX = 'bg-popup-hide-'
const HIDE_MS = 24 * 60 * 60 * 1000

function storageKey (idx) {
  return STORAGE_PREFIX + String(idx)
}

export function isPopupHidden (idx) {
  if (idx == null || idx === '') return true
  const raw = window.localStorage.getItem(storageKey(idx))
  if (!raw) return false
  const expires = Number(raw)
  if (!Number.isFinite(expires) || Date.now() >= expires) {
    window.localStorage.removeItem(storageKey(idx))
    return false
  }
  return true
}

export function hidePopupFor24Hours (idx) {
  if (idx == null || idx === '') return
  window.localStorage.setItem(storageKey(idx), String(Date.now() + HIDE_MS))
}

export function filterVisiblePopups (list) {
  if (!Array.isArray(list)) return []
  return list.filter(item => item && item.idx != null && !isPopupHidden(item.idx))
}

export function isPopupNoticeType (type) {
  return (Number(type) & 2) > 0
}

function escapeHtmlAttr (value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/</g, '&lt;')
}

function isSafeImageUrl (url) {
  const value = String(url || '').trim()
  if (!value) return false
  if (value.startsWith('/')) return true
  return /^https?:\/\//i.test(value)
}

/** type 2 팝업공지: text 필드에 이미지 URL이 들어옴 */
export function resolvePopupImageUrl (notice) {
  if (!notice || !isPopupNoticeType(notice.type)) return ''
  const text = String(notice.text || '').trim()
  if (!text || /<[a-z][\s\S]*>/i.test(text)) return ''
  return isSafeImageUrl(text) ? text : ''
}

export function buildNoticeImageHtml (url, alt = '') {
  const src = String(url || '').trim()
  if (!isSafeImageUrl(src)) return ''
  const safeSrc = escapeHtmlAttr(src)
  const safeAlt = escapeHtmlAttr(alt)
  return `<img src="${safeSrc}" alt="${safeAlt}" loading="lazy">`
}

export function toPopupContentHtml (text) {
  if (!text) return ''
  const value = String(text)
  if (/<[a-z][\s\S]*>/i.test(value)) return value
  return value.replace(/\n/g, '<br>')
}

function stripStyleDimensionRules (style) {
  return String(style || '')
    .replace(/(?:^|;)\s*(?:width|height|max-width|max-height|min-width|min-height)\s*:[^;]+;?/gi, '')
    .replace(/^\s*;|;\s*$/g, '')
    .trim()
}

export function sanitizeNoticeImages (html) {
  if (!html) return ''
  return String(html).replace(/<img\b([^>]*)>/gi, (match, attrs) => {
    let cleaned = String(attrs)
      .replace(/\s(?:width|height)\s*=\s*(?:"[^"]*"|'[^']*'|\S+)/gi, '')

    cleaned = cleaned.replace(/\sstyle\s*=\s*"([^"]*)"/gi, (full, style) => {
      const next = stripStyleDimensionRules(style)
      return next ? ` style="${next}"` : ''
    })
    cleaned = cleaned.replace(/\sstyle\s*=\s*'([^']*)'/gi, (full, style) => {
      const next = stripStyleDimensionRules(style)
      return next ? ` style='${next}'` : ''
    })

    return `<img${cleaned}>`
  })
}

export function prepareNoticeContentHtml (text) {
  return sanitizeNoticeImages(toPopupContentHtml(text))
}

/** 공지/팝업 항목 → 표시 HTML (type 2면 text를 이미지 URL로 사용) */
export function prepareNoticeContentFromItem (notice) {
  if (!notice) return ''
  const imageUrl = resolvePopupImageUrl(notice)
  if (imageUrl) {
    return buildNoticeImageHtml(imageUrl, notice.title)
  }
  return prepareNoticeContentHtml(notice.text)
}

export function isImagePopupContent (text) {
  const html = prepareNoticeContentHtml(text)
  if (!/<img\b/i.test(html)) return false
  const textOnly = html.replace(/<[^>]+>/g, '').replace(/\s+/g, '')
  return textOnly.length < 24
}

export function isNoticeImageContent (notice) {
  if (!notice) return false
  if (resolvePopupImageUrl(notice)) return true
  return isImagePopupContent(notice.text)
}
